import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { provideTranslocoScope, TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { TranslocoCurrencyPipe, TranslocoDatePipe, TranslocoLocaleService } from '@jsverse/transloco-locale';
import { EnvironmentService } from 'core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faHandPointUp } from '@fortawesome/free-regular-svg-icons';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-test-page',
  imports: [TranslocoPipe,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatIconModule,
    TranslocoDirective,
    TranslocoDatePipe,
    TranslocoCurrencyPipe,
    FontAwesomeModule
  ],
  providers: [ provideTranslocoScope('test')],
  templateUrl: './test-page.html',
  styleUrl: './test-page.scss'
})
export class TestPage {
  private transloco = inject(TranslocoService);
  private locale = inject(TranslocoLocaleService);
  private env = inject(EnvironmentService);

  baseUrl = this.env.baseApiUrl();

  faHandPointUp = faHandPointUp;
  faMagnifyingGlass = faMagnifyingGlass;

  today = new Date();
  price = 1499.99;
  count = 0;

  gender = 'male';

  languages = ['it-IT', 'en-GB', 'en-US', "fr-FR"];
  currentLang = this.transloco.getActiveLang();

  constructor(private httpClient: HttpClient) {
    // Assicurati che anche locale (date/valute) parta coerente con la lingua attiva
    this.locale.setLocale(this.currentLang);
  }

  onChange(event: Event) {
    const lang = (event.target as HTMLSelectElement).value;

    if (!this.languages.includes(lang)) return;

    this.currentLang = lang;
    this.transloco.setActiveLang(lang);
    this.locale.setLocale(lang);
  }

  increment() {
    this.count++;
  }

  pressbtn() {
    this.httpClient.get('api/navigation/routes').subscribe(response => {
      console.log('rotte', response);
    });
  }

  onClick() {
    console.log('click');
  }

  setLang(lang: string) {
    if (!this.languages.includes(lang)) return;

    this.currentLang = lang;
    this.transloco.setActiveLang(lang);
    this.locale.setLocale(lang);
  }
}